import { Outlet, type RouteObject } from "react-router-dom";
import WorkspaceScreen from "../screens/workspace/workspace.screen";
import CreateWorkspaceScreen from "../screens/workspace/create-workspace.screen";
import { Slider } from "../components/movables/slider.movable";
import AccountScreen from "../screens/account/account.screen";
import ProfileScreen from "../screens/account/profile.screen";
import ProposalScreen from "../screens/proposal/proposal.screen";
import { CommentsSliderPartial } from "../partials/menu/proposal/comments.partial";
import { ManageFiltersPartial } from "../partials/menu/proposal/manage-filters.partial";
import CampaignsScreen from "../screens/campaign/campaigns.screen";
import LiveCampaignScreen from "../screens/campaign/live-campaign.screen";
import CampaignScreen from "../screens/campaign/campaign.screen";
import CreateCampaignScreen from "../screens/campaign/create-campaign.scree";
import UpdateCampaignScreen from "../screens/campaign/update-campaign.screen";
import CampaignMetricsScreen from "../screens/campaign/campaign-metrics.screen";
import LivePostsScreen from "../screens/campaign/live-posts.screen";
import ClosedCampaignScreen from "../screens/campaign/closed-campaign.screen";
import DraftCampaignScreen from "../screens/campaign/draft-campaign.screen";
import DraftPostsScreen from "../screens/campaign/draft-posts.screen";
import { RejectPostModal } from "../components/core/post-reject.core";
import { Modal } from "../components/movables/modal.movable";
import PostSubmissionScreen from "../screens/campaign/post-submission.screen";
import CampaignPostsSearchScreen from "../screens/campaign/campaign-post-search.screen";
import CampaignShipmentsScreen from "../screens/campaign/campaign-shipments.screen";
import CampaignPostDetailsScreen from "../screens/campaign/campaign-post-details.screen";
import CampaignReleaseEarningsScreen from "../screens/campaign/campaign-release-earnings.screen";

export const brandRouter: Array<RouteObject> = [
  {
    path: "workspace",
    element: <Outlet />,
    children: [
      {
        path: "join",
        element: <WorkspaceScreen />,
      },
      {
        path: "create",
        element: <CreateWorkspaceScreen />,
      },
    ],
  },
  {
    path: "proposals",
    element: <Outlet />,
    children: [
      {
        path: ":proposalId",
        element: <ProposalScreen />,
        children: [
          {
            path: "comments/:proposalSocialId",
            element: (
              <Slider
                navigatePath="/brands/proposals/:proposalId"
                className="px-0"
              >
                <CommentsSliderPartial />
              </Slider>
            ),
          },
          {
            path: "manage-filters",
            element: (
              <Slider
                navigatePath="/brands/proposals/:proposalId"
                className="px-0"
              >
                <ManageFiltersPartial />
              </Slider>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "campaigns",
    element: <CampaignsScreen />,
    children: [
      {
        path: "live",
        element: <LiveCampaignScreen />,
      },
      {
        path: "draft",
        element: <DraftCampaignScreen />,
      },
      {
        path: "closed",
        element: <ClosedCampaignScreen />,
      },
    ],
  },
  {
    path: "campaigns/create",
    element: <CreateCampaignScreen />,
  },
  {
    path: "campaigns/:campaignId/update",
    element: <UpdateCampaignScreen />,
  },

  {
    path: "campaigns/:campaignId",
    element: <CampaignScreen />,
    children: [
      {
        path: "search",
        element: <CampaignPostsSearchScreen />,
      },
      {
        path: "metrics",
        element: <CampaignMetricsScreen />,
        children: [
          {
            path: "release-earnings",
            element: (
              <Modal navigatePath="/brands/campaigns/:campaignId/metrics">
                <CampaignReleaseEarningsScreen />,
              </Modal>
            ),
          },
        ],
      },
      {
        path: "live",
        element: <LivePostsScreen />,
        children: [
          {
            path: ":postId",
            element: (
              <Slider
                navigatePath="/brands/campaigns/:campaignId/live"
                className="px-0 max-w-lg"
              >
                <CampaignPostDetailsScreen />
              </Slider>
            ),
          },
          {
            path: ":postId/flag",
            element: (
              <Modal navigatePath="/brands/campaigns/:campaignId/live">
                <RejectPostModal />
              </Modal>
            ),
          },
          {
            path: ":postId/disqualify",
            element: (
              <Modal navigatePath="/brands/campaigns/:campaignId/live">
                <RejectPostModal />
              </Modal>
            ),
          },
        ],
      },
      {
        path: "post",
        element: <PostSubmissionScreen />,
        children: [
          {
            path: ":postId",
            element: (
              <Slider
                navigatePath="/brands/campaigns/:campaignId/post"
                className="px-0 max-w-lg"
              >
                <CampaignPostDetailsScreen />
              </Slider>
            ),
          },
          {
            path: ":postId/post-reject",
            element: (
              <Modal navigatePath="/brands/campaigns/:campaignId/post">
                <RejectPostModal />
              </Modal>
            ),
          },
        ],
      },
      {
        path: "draft",
        element: <DraftPostsScreen />,
        children: [
          {
            path: ":postId",
            element: (
              <Slider
                navigatePath="/brands/campaigns/:campaignId/draft"
                className="px-0 max-w-lg"
              >
                <CampaignPostDetailsScreen />
              </Slider>
            ),
          },
          {
            path: ":postId/draft-reject",
            element: (
              <Modal navigatePath="/brands/campaigns/:campaignId/draft">
                <RejectPostModal />
              </Modal>
            ),
          },
        ],
      },
      {
        path: "shipments",
        element: <CampaignShipmentsScreen />,
      },
    ],
  },

  {
    path: "account",
    element: <AccountScreen />,
    children: [
      {
        path: "profile",
        element: <ProfileScreen />,
      },
    ],
  },
];
